// @flow

import * as React from 'react';
import {useContext, useReducer} from 'react';
import type {Account, Country, Locale, Navigation} from 'docs/data';
import {useApi} from 'docs/data';
import {contextStubFunction} from 'docs/util';
import {AccountReducer} from './AccountReducer';
import type {AccountReducerState} from './AccountReducer';
import {setCountry} from './actions/setCountry';
import {setLocale} from './actions/setLocale';

export type AccountActions = {|
  setCountry: (country: Country, setNavigation: Navigation) => Promise<void>,
  setLocale: (locale: Locale, setNavigation: Navigation) => Promise<void>,
|};

export type AccountContextType = {
  ...AccountReducerState,
  ...AccountActions,
};

const AccountContext = React.createContext<AccountContextType>({
  account: ({}: any),
  isLoading: false,
  setCountry: contextStubFunction('Account'),
  setLocale: contextStubFunction('Account'),
});

type AccountProviderProps = {
  account: Account,
  children?: React.Node,
};

export const AccountProvider = (props: AccountProviderProps) => {
  const {api} = useApi();

  const [state, dispatch] = useReducer(AccountReducer, {
    account: props.account,
    isLoading: false,
  });

  const context = {
    ...state,
    setCountry: setCountry(api, dispatch),
    setLocale: setLocale(api, dispatch),
  };

  return (
    <AccountContext.Provider value={context}>
      {props.children}
    </AccountContext.Provider>
  );
};

export const useAccount = () => {
  return useContext(AccountContext);
};
